
/* ------------------------------------------------------------------------ */
/*		File: Plans.tsx                                                     */
/*		Description: Plans page definition                                  */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */

/* eslint-disable react/jsx-pascal-case */

import React, { useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { colorType } from "../../components/GenericComponents/generic.d";
import PlansMenu from "../../components/cmpMenu/cmpPlansMenu";
import IntroComponent from "../../components/cmpIntro/cmpIntro";
import { useChatbot } from "../../context/ChatbotContext";
import "./plans.css"; 
import "../../scss/general.css";
import PreviewPlan from "../../components/cmpPreviewPlan/cmpPreviewPlan";
import Plan from "../../components/cmpPlan/cmpPlan";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../components/GenericComponents/Button";
import Card_Breadcumb from "../../components/cmpBreadcumb/cmpBreadcumb";
import Group from "../../components/cmpGroup/cmpGroup";
import Meta from "../../components/GenericComponents/meta";


/* ------------------------------------------------------------------------ */

const Plans: React.FC = () => {
    const { t } = useTranslation();
    const params = useParams();
    const navigate = useNavigate();
    const { isOpened, setIsOpened } = useChatbot();

    const infoMenus:any = t("menu", { returnObjects: true }); 
    const infoPlans:any = t("plans", { returnObjects: true });
    const infoGroups:any = t("groups", { returnObjects: true });
    const detailMenu = infoMenus.filter((x:any) => x.id === "plans")[0] || null;
    const infoGroupViewport: any = infoGroups; 

    const [showPlan, setShowPlan] = useState<number>(parseInt(params.id!) || 1);

    return (
        <div className="header-parent ">
            <Meta page={"plans"} />
            <div className="cssPlans">
                <PlansMenu 
                    label={detailMenu!.label}
                    options={detailMenu!.submenus}
                    buttons={detailMenu!.buttons}
                    quotation={detailMenu!.quotation}
                    groups={infoGroups}
                    setShowPlan={setShowPlan}
                />
                <div className="cssCol">
                    <Card_Breadcumb label={infoPlans.breadcumb} />

                    {/* Section:Plans */}
                    
                    <section id="plans">
                        <IntroComponent
                            label={infoPlans.label}
                            description={infoPlans.description}
                        />
                    </section>

                    {/* Section: Preview of the Plans  */}
                    
                    <section id="previewPlan">
                        <div className="cssRowCenter">
                            {infoPlans.content[0].content.map((item:any, index:number) => (
                                <PreviewPlan
                                    label={item.label}
                                    description={item.description}
                                    options={item.content}
                                    hasButton={item.button_label !== null}
                                    hasIconButton={true}
                                    textButton={item.button_label}
                                    onClick={() => setShowPlan(index+1)}
                                />
                            ))}
                        </div> 
                    </section>

                    {/* Section: Detail of a Plan  */}

                    <section id={`detailPlan/${showPlan}`}>
                        <IntroComponent
                            label={infoPlans.content[showPlan].label}
                            description={infoPlans.content[showPlan].description}
                        />
                        <div id={`detailPlan/${showPlan}`}>
                            {infoPlans.content[showPlan].content.map((item:any, index:number) => (
                                <Plan
                                    key={`plan-${index}`}
                                    label={item.label}
                                    price={item.price}
                                    options={item.content}
                                    hasFreeClasses={item.freeClasses !== null}
                                    freeClasses={item.freeClasses !== null ? item.freeClasses : {} }
                                    isPopular={item.isPopular}                           
                                />
                            ))}
                        </div>

                        <div className="group_container_viewport">
                            {infoGroupViewport! !== null && (
                                <Group
                                    card={infoGroupViewport!}
                                />
                            )}

                        </div>
                    
                        <div className="cssPlans_button">
                            <Button 
                                classProp={"red-button"}
                                label={infoPlans.content[showPlan].button_label}
                                hasIcon={true}
                                src={infoPlans.content[showPlan].button_icon}
                                size={"big"}
                                textColor={colorType.BLUE}
                                onClick={() => infoPlans.content[showPlan]?.navigateTo.includes("symy") ? setIsOpened(true) : navigate(`${infoPlans.content[showPlan]?.navigateTo}`)}
                            />
                        </div>

                    </section>
                </div>
            </div>

        </div>
    );
};
export default withTranslation('translation', { withRef: true }) (Plans);    